import { render, staticRenderFns } from "./AddToItineraryModal.vue?vue&type=template&id=bf5b93e4&"
import script from "./AddToItineraryModal.vue?vue&type=script&lang=js&"
export * from "./AddToItineraryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports